import React from 'react';
import { Flex, Text } from '@chakra-ui/react';
import { SocialsCircle } from './socialsCircle';
import { t } from 'i18next';
import Vendor from '../../vendor.config';
import { Color } from 'src/theme/color';

const socials = [
	{
		uri: Vendor.data.externalUri.linkedin,
		name: 'linkedin',
	},
	{
		uri: Vendor.data.externalUri.telegram,
		name: 'telegram',
	},
	{
		uri: Vendor.data.externalUri.twitter,
		name: 'twitter',
	},
	{
		uri: Vendor.data.externalUri.facebook,
		name: 'facebook',
	},
	{
		uri: Vendor.data.externalUri.instagram,
		name: 'instagram',
	},
];

export const Socials = ({ hasDescription = false }: { hasDescription?: boolean }) => {
	return (
		<Flex
			alignItems="baseline"
			gridGap="48px"
		>
			{hasDescription && (
				<Flex
					justifyContent={{ base: 'center', md: 'auto' }}
					width={{ base: '100%', md: 'auto' }}
					textTransform="uppercase"
				>
					<Text color={Color.TEXT}>{t('menu.our').toString()}</Text>&nbsp;
					<Text color={Color.ACTION}>{t('menu.social').toString()}</Text>
				</Flex>
			)}
			<Flex gridGap="16px">
				{socials.map(social => (
					<SocialsCircle
						key={social.uri}
						data={social}
					/>
				))}
			</Flex>
		</Flex>
	);
};
